<template>
  <div class="main-container scrollbar-y">
    <div class="page-header">
      <div class="page-title">{{pageTitle}}表单</div>
      <div class="btn-container">
        <span class="btn save-btn" @click="handlerSave">保存</span>
        <span class="btn back-btn" @click="handlerBackToList">返回至列表</span>
      </div>
    </div>
    <div class="page-body">
      <el-form class="ezz-form" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="18">
            <el-row>
              <el-col :span="8">
                <el-form-item :label="pageTitle+'标题'" required>
                  <el-input v-model="form.title" size="small"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="所属类别" required="">
                  <el-cascader size="small" v-model="categoryIds" :options="categories" :props="{ checkStrictly: true }" style="width: 100%;"></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="关键字">
                  <el-input v-model="form.keywords" size="small"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="作者">
                  <el-input v-model="form.author" size="small"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="图片集形式">
                  <el-select v-model="form.image_show_type" size="small" placeholder="请选择" style="width: 100%">
                    <el-option v-for="item in imageShowTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="发布日期">
                  <el-date-picker v-model="form.release_time" size="small" type="date" placeholder="发布日期" :clearable="false" style="width: 100%"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="排序">
                  <el-input-number size="small" v-model="form.sort" controls-position="right" :min="1" style="width: 100%;"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="是否置顶">
                  <el-select v-model="form.is_top" size="small" placeholder="请选择" style="width: 100%">
                    <el-option v-for="item in isTop" :key="item.status" :label="item.label" :value="item.status"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="外部连接">
                  <el-input size="small" v-model="form.link" placeholder="填写此项，将直接跳转至“外部连接”"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="内容摘要" style="padding-top: 5px; padding-bottom: 8px;">
                  <el-input size="small" type="textarea" v-model="form.digest"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="内容详情">
                  <span id="editor" v-html="form.content"></span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-form-item size="small" label="图片集">
              <el-upload :show-file-list="false" :action="this.$apis.uploadFiles" :on-success="imageUploadSuccess">
                <el-button type="warning" size="small"><i class="el-icon-upload"></i> 上传图片</el-button>
              </el-upload>
              <el-row class="img-list" :gutter="20">
                <el-col :span="12" v-for="(item, index) in form.images" :key="index">
                  <img :src="web_Url+item.file_url" style="width: 100%;" />
                  <div>图片说明：</div>
                  <el-input type="textarea" v-model="item.file_txt"></el-input>
                  <div>排序</div>
                  <el-input v-model="item.sort"></el-input>
                  <div class="img-item-tools">
                    <div><span @click="setThumb(index)" :style="{color: item.is_thumb === '是' ? '#0a0' : '#aaa'}"><i class="el-icon-picture-outline-round"></i> 缩略图</span></div>
                    <div><span @click="delItem(index)" style="color: #a00;"><i class="el-icon-remove-outline"></i> 删除</span></div>
                  </div>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item size="small" label="附件">
              <el-upload :show-file-list="false" :action="this.$apis.uploadFiles" :on-success="fileUploadSuccess">
                <el-button type="success" size="small"><i class="el-icon-upload"></i> 上传附件</el-button>
              </el-upload>
              <ul class="file-list">
                <li class="file-item" v-for="(item, index) in form.attaches" :key="index">
                  <el-input v-model="item.file_name"></el-input>
                  <i class="el-icon-remove-outline" v-on:click="delFileItem(index)"></i>
                </li>
              </ul>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<style>
.explain-label {
  position: relative;
  top: -3px;
  color: #999;
  font-size: 12px;
  margin-left: 3px;
}
ul.file-list {
  padding: 0;
  margin: 0;
  list-style: none;
}
ul.file-list > li.file-item {
  position: relative;
  padding-right: 20px;
}
ul.file-list > li.file-item > i {
  position: absolute;
  font-size: 18px;
  top: 5px;
  right: 0px;
  color: #a00;
  cursor: pointer;
}
.img-item-tools {
  display: flex;
}
.img-item-tools > div {
  flex: 1;
  text-align: center;
}
.img-item-tools > div > span {
  cursor: pointer;
}
</style>
<script>
import apis from './module.apis.js'
export default {
  name: 'article_form',
  data: () => {
    return {
      form: {
        id: '',
        title: '',
        category_id: '0',
        category_ids: '',
        author: '',
        keywords: '',
        digest: '',
        content: '',
        is_page: '0',
        is_top: '0',
        image_show_type: '0',
        link: '',
        release_time: '',
        sort: 9,
        attaches: [],
        images: []
      },
      web_Url: window.g.baseUrl,
      categories: [],
      categoryIds: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      emptyFileData: {
        file_type: '',
        raw_file_name: '',
        file_name: '',
        file_url: '',
        file_txt: '',
        sort: 1,
        is_thumb: '否'
      },
      // 是否置顶
      isTop: [
        { status: '0', label: '否' },
        { status: '1', label: '是' }
      ],
      // 图片展示方式
      imageShowTypes: [
        { value: '0', label: '列表' },
        { value: '1', label: '幻灯片' }
      ],
      // 页面标题
      pageTitle: '',
      type: ''
    }
  },
  mounted: function () {
    const nowDate = this.$moment(new Date()).format('YYYY-MM-DD')
    const _type = this.$route.params.type
    this.type = _type
    this.form.is_page = _type === 'page' ? '1' : '0'
    this.pageTitle = _type === 'page' ? '单页面' : '文章'
    const _categoryIds = this.$route.params.categoryIds
    if (_categoryIds) this.categoryIds = _categoryIds.split(',')

    this.form.release_time = nowDate
    this.loadData()
  },
  methods: {
    loadData: function () {
      const _this = this
      _this.post(apis.getArticle, { id: _this.$route.params.id === null || _this.$route.params.id === undefined ? '0' : _this.$route.params.id }, function (res) {
        const _json = res.data
        if (_json.formData !== null) {
          _this.form = _json.formData
          _this.form.is_top = _this.form.is_top === '0' ? '0' : '1'
          // 设置文章分类，默认被选中项
          if (_this.form.category_ids !== '') {
            _this.categoryIds = _this.form.category_ids.split(',')
          }
        }
        _this.categories = _json.categories
        _this.editorInit()
      })
    },
    editorInit: function () {
      const _this = this
      CKEDITOR.replace('editor', {
        // 在ckeditor的config.js中配置
        //toolbar: 'Company',
        height: 500,
        width: 'auto'
      })
      CKEDITOR.instances.editor.on('change', (e) => {
        _this.getEditorContent()
      })
    },
    // 获取文字内容
    getEditorContent: function () {
      this.form.content = CKEDITOR.instances.editor.getData()
    },
    // 保存
    handlerSave: function (_index, _row) {
      const _this = this
      if (_this.form.title === '') {
        _this.$message({
          message: '请填写' + _this.pageTitle + '标题',
          type: 'warning'
        })
        return
      }
      if (_this.categoryIds.length === 0) {
        _this.$message({
          message: '请选择所属类别',
          type: 'warning'
        })
        return
      }
      _this.form.category_ids = _this.categoryIds.join(',')
      const _len = _this.categoryIds.length
      _this.post(apis.saveArticle, _this.form, function (res) {
        const _json = res.data
        if (_json.status === 'ok') {
          _this.$message({
            message: '操作成功',
            type: 'success'
          })
          // 传递类别id的目的，是让列表页的类别，默认选中当前传递的类别
          window.location.hash = '/article/list/'
        } else {
          _this.$message.error('操作失败')
        }
      })
    },

    /*
     * 返回列表页，传递类别id的目的，是让列表页的类别，默认选中当前传递的类别
     */
    handlerBackToList: function () {
      const _this = this
      const _len = _this.categoryIds.length
      this.$router.replace({
        path: '/article/list/'
      })
    },

    /*
     * 下载文件
     */
    downloadFile: function (_fileUrl) {
        window.open(this.web_Url + _fileUrl)
    },

    /*
     * 附件上传成功的回调方法
     */
    fileUploadSuccess: function (res) {
      const _this = this
      const _status = res.status
      if (_status === 'ok') {
        const _fileInfo = res.fileInfo
        const _newFile = JSON.parse(JSON.stringify(this.emptyFileData))

        _newFile.raw_file_name = _fileInfo.raw_file_name
        _newFile.file_name = _fileInfo.file_name
        _newFile.file_type = _fileInfo.file_type
        _newFile.file_url = _fileInfo.file_url
        _newFile.file_size = _fileInfo.file_size

        _this.form.attaches.push(_newFile)
      }
    },
    imageUploadSuccess: function (res) {
      var _this = this
      if (_this.form.images === null) _this.form.images = []
      var _imgCount = _this.form.images.length

      var _status = res.status
      if (_status === 'ok') {
        const _fileInfo = res.fileInfo
        var _newImg = JSON.parse(JSON.stringify(_this.emptyFileData))
        _newImg.raw_file_name = _fileInfo.raw_file_name
        _newImg.file_name = _fileInfo.file_name
        _newImg.file_type = _fileInfo.file_type
        _newImg.file_url = _fileInfo.file_url
        _newImg.file_size = _fileInfo.file_size
        _newImg.sort = ++_imgCount
        _this.form.images.push(_newImg)
      } else {
        _this.$message.error(res.message)
      }
    },
    delFileItem: function (_index) {
      var _this = this
      _this
        .$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          _this.$delete(_this.form.attaches, _index)
        })
        .catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    setThumb: function (_index) {
      this.form.images.forEach((item) => {
        item.is_thumb = '否'
      })
      var item = this.form.images[_index]
      item.is_thumb = '是'
    },
    delItem: function (_index) {
      var _this = this
      _this
        .$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          _this.$delete(_this.form.images, _index)
        })
        .catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
